import styled, { css } from 'styled-components';
import { Button, parseTypography } from '@kueski-dev/kueski-design-system';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const CardContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    width: 446px;
    @media ${theme.breakpoint.onlyPhone} {
      padding: 0 ${theme.spacing.layout02};
      width: 100%;
    }
  `}
`;

export const UnderlineButton = styled(Button)`
  ${({ theme }) => css`&& {
    ${parseTypography('Text/Title/Small/Medium')}
    border: 0;
    color: ${theme.color.primary};
    margin: 0 ${theme.spacing.spacing02};
    padding: 0;
    text-decoration: underline;
    width: auto;
  }`}
`;
